import { enableProdMode, ErrorHandler, APP_INITIALIZER, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';

import { SentryErrorHandler, initApp } from './app/app.module';
import { environment } from './environments/environment';
import { SentryService } from './app/core/services/sentry.service';
import { ApplicationService } from './app/core/services/application.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtInterceptor } from './app/auth/jwt.interceptor';
import { VersionInterceptor } from './app/core/version.interceptor';
import { SessionTimeoutInterceptor } from './app/core/session-timeout.interceptor';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CoreModule } from './app/core/core.module';
import { SharedModule } from './app/shared/shared.module';
import { AuthModule } from './app/auth/auth.module';
import { AppRoutingModule } from 'app/app-routing.module';
import { CapturesModule } from './app/captures/captures.module';
import { CaptureAdminModule } from './app/capture-admin/capture-admin.module';
import { LlmPlaygroundModule } from './app/llm-playground/llm-playground.module';
import { ClientPortalModule } from './app/client-portal/client-portal.module';
import { PartnerPortalModule } from './app/partner-portal/partner-portal.module';
import { HotkeyModule } from 'angular2-hotkeys';
import { AppComponent } from './app/app.component';
import { AuthRoutingModule } from 'app/auth/auth-routing.module';
import { IccModule } from 'app/icc/icc.module';

if (environment.production) {
  enableProdMode();
}

if (environment.helpscoutApi && environment.helpscoutApi.token) {
  const script = document.createElement('script');
  script.innerHTML =
    '!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});';
  document.head.appendChild(script);
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(
      BrowserModule,
      InfiniteScrollModule,
      CoreModule,
      SharedModule,
      AuthModule,
      AuthRoutingModule,
      AppRoutingModule,
      CapturesModule,
      CaptureAdminModule,
      LlmPlaygroundModule,
      ClientPortalModule,
      PartnerPortalModule,
      IccModule,
      HotkeyModule.forRoot()
    ),
    { provide: ErrorHandler, useClass: SentryErrorHandler, deps: [SentryService] },
    { provide: APP_INITIALIZER, useFactory: initApp, deps: [ApplicationService], multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: VersionInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SessionTimeoutInterceptor,
      multi: true,
    }
  ]
})
  .catch(err => console.log(err));
